import React from 'react';
import { CTAButton } from './CTAButton';
export function IncludesSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const modules = [{
    icon: '📘',
    title: 'Tomo 1: Luxury Brow Extensions',
    description: 'Vas a aprender a fondo sobre: extensión de cejas pelo por pelo, mapping, diseño estratégico, visagismo, simetría facial, corrección de huecos, acabado hiperrealista, laminado, colorimetría, mantenimiento y retoques.'
  }, {
    icon: '📖',
    title: 'Tomo 2: Guía Práctica Paso a Paso',
    description: 'Aprendé en detalle cómo se realiza la técnica correctamente. Incluye el paso a paso de: aplicación, dirección del vello, fijación, reconstrucción, acabado premium y los errores comunes que debés evitar.'
  }, {
    icon: '📲',
    title: 'Tomo 3: Pack Marketing para Conseguir Clientas',
    description: 'Porque no alcanza solo con aprender la técnica, también necesitás posicionarte. Este módulo incluye: ✅ ideas de reels ✅ contenido viral ✅ fotos que venden ✅ branding beauty premium ✅ estrategias para Instagram ✅ cómo captar clientas que ya se hacen pestañas y microblading.'
  }, {
    icon: '💰',
    title: 'Tomo 4: Estrategia de Negocio y Fidelización',
    description: 'Aprendé la estrategia detrás del negocio: cómo transformar este servicio en ingresos mensuales, cómo crear mantenimientos, cómo hacer retoques recurrentes, cómo aumentar tu ticket promedio y cómo vender packs mensuales.'
  }];
  return <section className="py-8 md:py-12 px-4 bg-[#2E0640] mt-[0px] mb-[0px] pt-[0px] pb-[0px]" data-id="element-224">
      <div className="max-w-6xl mx-auto mt-[-30px] mb-[-30px]" data-id="element-225">
        <h2 className="text-4xl md:text-5xl font-black text-center text-[#FFFFFF] mt-[35px] mb-[35px] pt-[10px] pb-[10px]" data-id="element-226">
          ¿Qué incluye exactamente?
        </h2>

        <div className="flex justify-center mb-12" data-id="element-227">
          <img src="https://cdn.magicpatterns.com/uploads/arVKmUfcTzBbjKrBKaxKGn/mockup_dominando_shopify.png" alt="Mockup Dominando Shopify - Curso completo" className="w-full max-w-3xl rounded-2xl mt-[-23px] mb-[-23px] pt-[0px] pb-[0px]" data-id="element-228" />
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-2xl p-8 md:p-12 bg-[#2F0240] animate-neon-violet pt-[35px] pb-[35px] mt-[30px] mb-[30px]" data-id="element-229">
          <h3 className="font-bold mb-8 text-center text-[29px]" data-id="element-230">
            El sistema completo 👇🏻
          </h3>
          <p className="mb-6 text-center text-gray-300 text-[20px]" data-id="element-231">
            📙4 Tomos organizados. 📘27 clases con el paso a paso completo. 📒6
            bonos estratégicos.
          </p>

          <div className="grid md:grid-cols-2 gap-5" data-id="element-232">
            {modules.map((module, index) => <div key={index} className="bg-gray-800 rounded-xl p-5 border border-[#FC9DFF]/20" data-id="element-233">
                <h4 className="text-white font-bold text-[17px] md:text-lg mb-2 leading-snug" data-id="element-234">
                  <span className="mr-1" data-id="element-235">{module.icon}</span>
                  {module.title}
                </h4>
                <p className="text-gray-300 text-[15px] md:text-base leading-relaxed" data-id="element-236">
                  {module.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}